<script setup lang="ts">
import { enUS } from 'date-fns/locale'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

import { faCalendar } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppSelect, AppSelectSearchable } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useFiltersTutorSlotLog } from '../../model/shift-control/filters-tutor-slot-log.hook'

defineOptions({
  name: 'FiltersTutorSlotLog',
})

const {
  refTutorId,
  refSelectedTutor,
  tutorOptions,
  tutorHasMore,
  tutorLoading,
  onTutorSearch,
  onTutorLoadMore,
  onTutorOpen,
  refDate,
  refSlotTime,
  slotTimeOptions,
  isSearchDisabled,
  isLoading,
  handleSearch,
  handleClear,
} = useFiltersTutorSlotLog()
</script>

<template>
  <div class="box-filters-tutor-slot-log">
    <AppSelectSearchable
      v-model="refTutorId"
      :options="tutorOptions"
      :selected-option="refSelectedTutor"
      :has-more="tutorHasMore"
      :loading="tutorLoading"
      label="Tutor name"
      placeholder="Tutor name"
      clearable
      infinite
      @search="onTutorSearch"
      @load-more="onTutorLoadMore"
      @open="onTutorOpen"
    />

    <div class="box-filters-tutor-slot-log__date">
      <AppText
        name="body2"
        color="slate-900"
        class="box-filters-tutor-slot-log__date-label"
      >
        Date
      </AppText>
      <Datepicker
        v-model="refDate"
        :locale="enUS"
        :week-start="1"
        :formats="{ input: 'yyyy-MM-dd' }"
        :time-config="{ enableTimePicker: false }"
        auto-apply
        clearable
        placeholder="Date"
        teleport
      >
        <template #input-icon>
          <AppIcon :icon="faCalendar" />
        </template>
      </Datepicker>
    </div>

    <AppSelect
      v-model="refSlotTime"
      :options="slotTimeOptions"
      label="Slot"
      placeholder="HH:mm"
      :disabled="isLoading"
      clearable
    />

    <BtnPrimary
      text="Search"
      :disabled="isSearchDisabled"
      element-width="auto"
      @click="handleSearch"
    />
    <BtnSecondary
      text="Clear"
      :disabled="isLoading"
      element-width="auto"
      @click="handleClear"
    />
  </div>
</template>

<style scoped lang="scss" src="./FiltersTutorSlotLog.scss" />
